<div class="container mx-auto px-4 py-8 max-w-2xl">
  <h2 class="text-2xl font-semibold text-gray-800 mb-3 uppercase text-center">CREAR NUEVO CLIENTE</h2>
  <div class="bg-white shadow-md rounded-lg px-8 py-6">
    <form [formGroup]="clientForm" (ngSubmit)="handleCreateClient()" class="space-y-4">
      <div *ngIf="isLoading" class="flex justify-center items-center mt-5">
        <mat-spinner class="text-orange-500 animate-spin" strokeWidth="3" [diameter]="70"></mat-spinner>
      </div>

      <div class="grid grid-cols-1 md:grid-cols-3 gap-6">

        <div class="w-full">
          <mat-form-field appearance="fill" class="w-full">
            <mat-label>CIF</mat-label>
            <input type="text" matInput formControlName="cif" id="cif" class="form-input mt-1 block w-full">
          </mat-form-field>
        </div>

        <div class="w-full">
          <mat-form-field appearance="fill" class="w-full">
            <mat-label>Delegación</mat-label>
            <input type="text" matInput formControlName="delegation" id="delegation"
              class="form-input mt-1 block w-full">
          </mat-form-field>
        </div>

        <div class="w-full">
          <mat-form-field appearance="fill" class="w-full">
            <mat-label>Código cliente</mat-label>
            <input type="number" matInput formControlName="clientCode" id="clientCode"
              class="form-input mt-1 block w-full">
          </mat-form-field>
        </div>

        <div class="w-full">
          <mat-form-field appearance="fill" class="w-full">
            <mat-label>Razón social</mat-label>
            <input type="text" matInput formControlName="socialReason" id="socialReason"
              class="form-input mt-1 block w-full">
          </mat-form-field>
        </div>

        <div class="w-full">
          <mat-form-field appearance="fill" class="w-full">
            <mat-label>Nombre</mat-label>
            <input type="text" matInput formControlName="name" id="name" class="form-input mt-1 block w-full">
          </mat-form-field>
        </div>

        <div class="w-full">
          <mat-form-field appearance="fill" class="w-full">
            <mat-label>Dirección</mat-label>
            <input type="text" matInput formControlName="fiscalAddress" id="fiscalAddress"
              class="form-input mt-1 block w-full">
          </mat-form-field>
        </div>

        <div class="w-full">
          <mat-form-field appearance="fill" class="w-full">
            <mat-label>Código postal fiscal</mat-label>
            <input type="text" matInput formControlName="fiscalPortalCode" id="fiscalPortalCode"
              class="form-input mt-1 block w-full">
          </mat-form-field>
        </div>
        <div class="w-full">
          <mat-form-field appearance="fill" class="w-full">
            <mat-label>Ciudad fiscal</mat-label>
            <input type="text" matInput formControlName="fiscalCity" id="fiscalCity"
              class="form-input mt-1 block w-full">
          </mat-form-field>
        </div>

        <div class="w-full">
          <mat-form-field appearance="fill" class="w-full">
            <mat-label>Provincia fiscal</mat-label>
            <input type="text" matInput formControlName="fiscalProvince" id="fiscalProvince"
              class="form-input mt-1 block w-full">
          </mat-form-field>
        </div>

        <div class="w-full">
          <mat-form-field appearance="fill" class="w-full">
            <mat-label>Pais fiscal</mat-label>
            <input type="text" matInput formControlName="fiscalCountry" id="fiscalCountry"
              class="form-input mt-1 block w-full">
          </mat-form-field>
        </div>

        <div class="w-full">
          <mat-form-field appearance="fill" class="w-full">
            <mat-label>Dirección de facturación</mat-label>
            <input type="text" matInput formControlName="billAddress" id="billAddress"
              class="form-input mt-1 block w-full">
          </mat-form-field>
        </div>

        <div class="w-full">
          <mat-form-field appearance="fill" class="w-full">
            <mat-label>Código postal de facturación </mat-label>
            <input type="text" matInput formControlName="billPostalCode" id="billPostalCode"
              class="form-input mt-1 block w-full">
          </mat-form-field>
        </div>
        <div class="w-full">
          <mat-form-field appearance="fill" class="w-full">
            <mat-label>Ciudad de facturación</mat-label>
            <input type="text" matInput formControlName="billCity" id="billCity" class="form-input mt-1 block w-full">
          </mat-form-field>
        </div>
        <div class="w-full">
          <mat-form-field appearance="fill" class="w-full">
            <mat-label>Provincia de facturación</mat-label>
            <input type="text" matInput formControlName="billProvince" id="billProvince"
              class="form-input mt-1 block w-full">
          </mat-form-field>
        </div>
        <div class="w-full">
          <mat-form-field appearance="fill" class="w-full">
            <mat-label>Pais de facturación</mat-label>
            <input type="text" matInput formControlName="billCountry" id="billCountry"
              class="form-input mt-1 block w-full">
          </mat-form-field>
        </div>
        <div class="w-full">
          <mat-form-field appearance="fill" class="w-full">
            <mat-label>Email</mat-label>
            <input type="text" matInput formControlName="email" id="email" class="form-input mt-1 block w-full">
          </mat-form-field>
        </div>
        <div class="w-full">
          <mat-form-field appearance="fill" class="w-full">
            <mat-label>Contacto de Facturación</mat-label>
            <input type="text" matInput formControlName="billContact" id="billContact"
              class="form-input mt-1 block w-full">
          </mat-form-field>
        </div>


      </div>


      <button type="submit" class="bg-orange-500 hover:bg-orange-700 text-white font-bold py-2 px-4 rounded">CREAR
        CLIENTE
      </button>

    </form>
  </div>
</div>